module.exports = __webpack_public_path__ + "img/1fa8ca6.webp";